export default __webpack_public_path__ + "static/media/bgfixed1.8180be78.jpeg";